import styles from '../settings.module.css';
import { CallAudioSettings } from './CallAudioSettings';

export const CallSettings = () => {
  return (
    <div className={styles.section}>
      <h2 className={styles.title}>911 Calls</h2>
      <div className={styles.description}>
        Manage audio notification preferences for all incoming emergency voice
        calls.
      </div>
      <div className={styles.cardBlock}>
        <CallAudioSettings />
      </div>
    </div>
  );
};
